var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "url(#pattern0_164_3)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_164_3",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_164_3",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_164_3",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAABGElEQVR4nO3aT0rDQBjG4eBO9/lA8BbCjBdxnW/lFVzWM/gHPaW60W0k4gEEmUljngdmXfJradqXDAMAAAAAAAAAAAB7dX55cxZleoo6vUfNeWfnLWo+XlxdnzYPPdbp5QgueF7zLA0aZz6cjCU/177QWD/0x9JC6Lr50L464jt0Pg+tLTeCqNPDz41h3tUp+Rol77vcDAEAAI6WmTTNpNFvvTOTRp/QZtL4H6HNpGEmTTMpAABAF2bSNJOGmTTXf5xrW+udx3bDTJodP9GeJp2bRvY0KQAAQCNjzduG/+YO3rjWsUXuEFvkDrFF7hBb5A6xRe4QW+S/+VVskTvELn4nt49dRG4fu4jc1Finu+W0fRUAgGGjvgBDPKopDXTjqAAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/Menu.34437d9ec9e427356f05d1a5eb52eba4.svg";
export { ForwardRef as ReactComponent };